import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.588 15.808l3.74 3.74 1.06-1.061L5.513 1.612l-1.06 1.06L8.179 6.4 4.54 7.613c-2.01.67-2.065 3.49-.087 4.238l5.493 2.19 2.191 5.493c.75 1.98 3.568 1.922 4.238-.085l1.214-3.641zm3.282-9.845l-2.222 6.663-7.287-7.287 6.661-2.22c1.759-.588 3.432 1.087 2.847 2.844z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.588 15.808l3.74 3.74 1.06-1.061L5.513 1.612l-1.06 1.06L8.179 6.4 4.54 7.613c-2.01.67-2.065 3.49-.087 4.238l5.493 2.19 2.191 5.493c.75 1.98 3.568 1.922 4.238-.085l1.214-3.641zm3.282-9.845l-2.222 6.663-7.287-7.287 6.661-2.22c1.759-.588 3.432 1.087 2.847 2.844z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M35.176 31.616l7.479 7.48 2.121-2.122-33.75-33.75-2.121 2.121L16.36 12.8l-7.282 2.427c-4.017 1.34-4.128 6.978-.172 8.476l10.986 4.382 4.382 10.983c1.497 3.96 7.134 3.846 8.475-.17l2.428-7.281zm6.563-19.689l-4.442 13.325-14.574-14.575 13.322-4.44c3.517-1.174 6.863 2.174 5.694 5.69z"
  }))
};
export var NavigationNullFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});